import React from "react";
import { ProductPageTabHeaderProps, TranslatedHeader } from "../../ProductPageTabHeaders";

const renderFAQs = (tabData?: any): boolean => {
  return !!tabData;
};

export const FAQsHeader = (props: ProductPageTabHeaderProps) => {
  if (!renderFAQs(props.tab?.value)) {
    return null;
  }
  return <TranslatedHeader {...props} />;
};
